import type { UseQueryOptions } from "@tanstack/react-query";
import { skipToken, useQuery } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import type { Project } from "../utils/backend-types";

export function useProject(
  projectId?: string | null,
  options?: Partial<UseQueryOptions<Project | undefined>>
) {
  const {
    data: project,
    isLoading,
    error
  } = useQuery({
    queryKey: ["project", { projectId }],
    queryFn: projectId ? () => fetchProject(projectId) : skipToken,
    staleTime: 60 * 1000, // 1 minute
    ...options
  });

  return { project, isLoading, error };
}

async function fetchProject(projectId: string) {
  const projectsDetailUrl = urls.api.projectsDetail(projectId);
  const response = await api.get<Project>(projectsDetailUrl);
  return response.data;
}
